import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

@HateoasResource('accounts', { routeName: 'billingResourceRoute' })
export class BillingAccount extends Resource {
    public id: string;
    public parentId: string;
    public attributionId: string;
    public active: boolean;
    public billingMode: string;
    public trialExpiresOn: string;
}
